var map = {
	"./al.svg": 49622,
	"./ar.svg": 53230,
	"./ar2.svg": 83353,
	"./ar3.svg": 32888,
	"./az.svg": 20868,
	"./ba.svg": 6063,
	"./cart.svg": 60737,
	"./china.svg": 32516,
	"./cn.svg": 13481,
	"./cnr.svg": 35065,
	"./copy.svg": 26696,
	"./cs.svg": 20864,
	"./de.svg": 66240,
	"./desk-bell.svg": 19475,
	"./en.svg": 19203,
	"./es.svg": 40426,
	"./et.svg": 82820,
	"./fa.svg": 18349,
	"./fr.svg": 73328,
	"./gr.svg": 17023,
	"./hamburger.svg": 30068,
	"./home.svg": 97397,
	"./hr.svg": 12524,
	"./hu.svg": 51219,
	"./icon-close.svg": 31103,
	"./il.svg": 68953,
	"./info.svg": 19666,
	"./it.svg": 30077,
	"./ja.svg": 19078,
	"./ka.svg": 88233,
	"./ko.svg": 71165,
	"./ky.svg": 20062,
	"./kz.svg": 31468,
	"./loading_product.svg": 18525,
	"./logo.svg": 9609,
	"./lv.svg": 45360,
	"./menu.svg": 35203,
	"./minus.svg": 52593,
	"./mn.svg": 17492,
	"./nav_1.svg": 17006,
	"./nav_10.svg": 85873,
	"./nav_11.svg": 67413,
	"./nav_12.svg": 47298,
	"./nav_13.svg": 31492,
	"./nav_2.svg": 34356,
	"./nav_3.svg": 88601,
	"./nav_4.svg": 52735,
	"./nav_5.svg": 35309,
	"./nav_6.svg": 79339,
	"./nav_7.svg": 20268,
	"./nav_8.svg": 96039,
	"./nav_9.svg": 64140,
	"./nl.svg": 97306,
	"./pl.svg": 10926,
	"./plus.svg": 6706,
	"./pt.svg": 54724,
	"./recognizing-in-progress.svg": 36487,
	"./ro.svg": 89967,
	"./ru.svg": 14683,
	"./rush-8.svg": 70940,
	"./service.svg": 31636,
	"./service_0.svg": 35709,
	"./service_1.svg": 9123,
	"./service_2.svg": 84510,
	"./service_3.svg": 47629,
	"./service_4.svg": 61856,
	"./service_5.svg": 31495,
	"./service_6.svg": 36782,
	"./sk.svg": 46224,
	"./sv.svg": 79061,
	"./tat.svg": 74045,
	"./tr.svg": 58879,
	"./ua.svg": 80805,
	"./uz.svg": 65167,
	"./wave.svg": 43450
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31151;